export default __webpack_public_path__ + "static/Rashawnd-289a1d9eb0c89db6f6ae9ff7e7f0b5a7.jpg";